import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import '../Dashboard/matchup.css';
import { Alert, Row, Col } from 'react-bootstrap';
import PlayerPanel from '../Dashboard/playerPanel';
import UserHeader from '../UserHeader';
import TeamLegend from '../Dashboard/teamLegend';
import { highlightColumn, highlightColumnColor, checkHealthScoreStatus, sortTopSoccerPlayers } from '../utils/dashboardCalculations';
import { sortArrayOfObj } from '../utils/utils';


function SoccerMatchup(props) {
	let { id: gameID } = useParams();
	useEffect(() => {
		window.scrollTo(0, 0);
		let { dispatch, match, healthScores, assignCurrentSport } = props;
		assignCurrentSport();
		if (!match.match || gameID) {
			dispatch({ type: 'GET_MATCH', payload: { gameID } });
			if (!healthScores.categoryAverages) {
				dispatch({ type: 'GET_HEALTH_SCORES', payload: { gameID } });
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [showAwayRoster, handleShowAwayRoster] = useState(true);
	const [showHomeRoster, handleShowHomeRoster] = useState(true);
	const [expandedAwayGroups, setExpandedAwayGroups] = useState({});
	const [expandedHomeGroups, setExpandedHomeGroups] = useState({});
	const [showSchedule, handleShowSchedule] = useState(false);
	const [propID, handlePropID] = useState(null);

	const toggleGroupAway = (groupId) => {
		setExpandedAwayGroups(prev => ({
			...prev,
			[groupId]: !prev[groupId]
		}));
	};

	const toggleGroupHome = (groupId) => {
		setExpandedHomeGroups(prev => ({
			...prev,
			[groupId]: !prev[groupId]
		}));
	};
	
	
	const toggleRosterView = (type) => {
		if (type === 'away') {
			handleShowAwayRoster(!showAwayRoster);
		} else if (type === 'home') {
			handleShowHomeRoster(!showHomeRoster);
		}
	};

	const { match, schedules, user, hideUserHeader, toggleScheduleView, healthScores, teams } = props;
	const title = 'Health Scores for Team Matchups';

	if (match.isLoading || healthScores.isLoading || user.isLoading)
		return (
			<div id='fullHeight'>
				<div id='loading' />
			</div>
		);
	if (!match.awayPlayers || !match.homePlayers) {
		return (
			<React.Fragment>
				<div className='gameMainDiv'>
					<UserHeader matchup={true} backgroundColor={'#f7f7f7'} title={title} />
					<h1
						className='bold text-center'
						dangerouslySetInnerHTML={{ __html: match.error }}
					/>
				</div>
			</React.Fragment>
		);
	}
	const game = match?.match[0];
	console.log(match,'match')
	let { awayPlayers, homePlayers } = match;

	let topFourAway = awayPlayers && sortTopSoccerPlayers(awayPlayers,match.topFourAway)
	let topFourHome = homePlayers && sortTopSoccerPlayers(homePlayers,match.topFourHome)
	console.log(topFourHome,'topFourHome')


	const awayRoster =
		awayPlayers &&
		awayPlayers.filter((x) => {
			if (x.active === 1) {
				return x;
			}
			return;
		});
	const homeRoster =
		homePlayers &&
		homePlayers.filter((x) => {
			if (x.active === 1) {
				return x;
			}
			return;
		});
	let positionGroups = Array.from(
		new Set(awayRoster.map(player => player.position?.toUpperCase()))
	).filter(Boolean).map(posCode => {
		switch (posCode) {
			case 'GK':
				return { id: posCode, label: 'GOALKEEPERS' };
			case 'D':
				return { id: posCode, label: 'DEFENDERS' };
			case 'M':
				return { id: posCode, label: 'MIDFIELDERS' };
			case 'F':
				return { id: posCode, label: 'FORWARDS' };
			case 'A':
				return { id: posCode, label: 'FORWARDS' };
			default:
				return { id: posCode, label: posCode || 'UNKNOWN' };
		}
	}).sort((a, b) => {
		// Sort by position order: G, D, M, A, F, others
		const order = { 'G': 1, 'D': 2, 'M': 3, 'A': 4, 'F': 5 };
		return (order[a.id] || 99) - (order[b.id] || 99) || a.label.localeCompare(b.label);
	});

	let positionHomeGroups = Array.from(
		new Set(homeRoster.map(player => player.position?.toUpperCase()))
	).filter(Boolean).map(posCode => {
		switch (posCode) {
			case 'GK':
				return { id: posCode, label: 'GOALKEEPERS' };
			case 'D':
				return { id: posCode, label: 'DEFENDERS' };
			case 'M':
				return { id: posCode, label: 'MIDFIELDERS' };
			case 'F':
				return { id: posCode, label: 'FORWARDS' };
			case 'A':
				return { id: posCode, label: 'FORWARDS' };
			default:
				return { id: posCode, label: posCode || 'UNKNOWN' };
		}
	}).sort((a, b) => {
		// Sort by position order: G, D, M, A, F, others
		const order = { 'G': 1, 'D': 2, 'M': 3, 'A': 4, 'F': 5 };
		return (order[a.id] || 99) - (order[b.id] || 99) || a.label.localeCompare(b.label);
	});

	// Parse roster players from API (homeRosterPlayers, awayRosterPlayers)
		const awayRosterPlayersResp = match?.awayRosterPlayers || [];
		const homeRosterPlayersResp = match?.homeRosterPlayers || [];
	
		// Helper to parse roster JSON and pick the correct team by full name
		const parseTeamRoster = (rows, teamFullName) => {
			if (!rows || !rows.length) return null;
			// Try to find a response JSON in any row
			const jsonStr = (rows.find(r => r && r.response && typeof r.response === 'string') || {})?.response;
			if (false && jsonStr) {
				try {
					const data = JSON.parse(jsonStr);
					const teams = Array.isArray(data?.teams) ? data.teams : [];
					const stripDiacritics = (s) => (s || '').normalize('NFD').replace(/\p{Diacritic}+/gu, '');
					const normBasic = (s) => (s || '').toString().trim().toLowerCase();
					const normalized = (s) => {
						const t = stripDiacritics(s).toLowerCase();
						return t.replace(/[^a-z0-9\s]/g, ' ').replace(/\s+/g, ' ').trim();
					};
					const target = normalized(teamFullName);
					const teamObj =
						teams.find(t => normalized(t?.team_name) === target) ||
						teams.find(t => normalized(`${t?.team_name}`)?.includes(normalized(game?.away_team_name)) || normalized(`${t?.team_name}`)?.includes(normalized(game?.home_team_name))) ||
						teams[0];
						if (teamObj) {
							// Build an index from SQL rows to enrich JSON players with IDs and details
						const nameKey = (obj) => normalized(obj?.full_name || obj?.player_name || obj?.nickname || obj?.name);
						const altKeys = (r) => {
							const keys = new Set();
							[key => key].forEach(() => {}); // no-op to satisfy lints for unused helpers
							[ r.full_name, r.player_name, r.nickname ].forEach(n => { if (n) keys.add(nameKey({ full_name: n })); });
							return Array.from(keys);
						};
						const rowIndex = new Map();
						(rows || []).forEach(r => {
							altKeys(r).forEach(k => { if (k && !rowIndex.has(k)) rowIndex.set(k, r); });
						});
							const enrich = (arr) => (arr || []).map(p => {
								const key = nameKey(p);
								let rowMatch = rowIndex.get(key);
							if (!rowMatch && p?.full_name) {
								// try a looser match: remove middle parts or compare startsWith
								const parts = normalized(p.full_name).split(' ');
								if (parts.length > 1) {
									const tryKey = `${parts[0]} ${parts[parts.length - 1]}`;
									rowMatch = rowIndex.get(tryKey) || rowIndex.get(parts[0]) || rowIndex.get(parts[parts.length - 1]);
								}
							}
								return {
									...p,
									full_name: p.full_name || p.player_name || rowMatch?.full_name || rowMatch?.player_name || p.name,
									player_id: p.player_id || rowMatch?.player_id,
									// Always prefer DB row fields for position and gaming_score
									position: rowMatch?.position || rowMatch?.position_map || rowMatch?.position_category || p.position,
									gaming_score: rowMatch?.gaming_score ?? p.gaming_score,
								};
							});
						return {
							team_name: teamObj.team_name,
							projected_starters: enrich(teamObj.projected_starters),
							active_roster: enrich(teamObj.active_roster),
							inactive_or_injured: enrich(teamObj.inactive_or_injured)
						};
					}
				} catch (e) {
					// fall back to building from rows
				}
			}
			// Build bundles directly from SQL rows (roaster_players): use player_name, player_id, position, gaming_score
			const toPlayer = (r) => ({
				player_id: r.player_id,
				role: r.role || (r.depth_chart_order === 1 ? 'Starter' : 'Bench'),
				position: r.position,
				gaming_score: r.gaming_score,
				full_name: r.player_name
			});
			const starters = rows.filter(r => (r.role && String(r.role).toLowerCase() === 'starter') || r.depth_chart_order === 1).map(toPlayer);
			const inactive = rows.filter(r => {
				const s = (r.status || r.injury_status || '').toString().toLowerCase();
				return s && s !== 'active';
			}).map(toPlayer);
			const active = rows.filter(r => {
				const s = (r.status || r.injury_status || '').toString().toLowerCase();
				return !s || s === 'active';
			}).map(toPlayer);
			if (!starters.length && !active.length && !inactive.length) return null;
			return {
				team_name: teamFullName,
				projected_starters: starters,
				active_roster: active,
				inactive_or_injured: inactive
			};
		};
	
		const awayTeamFullName = [game?.away_team_city, game?.away_team_name].filter(Boolean).join(' ');
		const homeTeamFullName = [game?.home_team_city, game?.home_team_name].filter(Boolean).join(' ');
		const awayRosterBundle = parseTeamRoster(awayRosterPlayersResp, awayTeamFullName);
		const homeRosterBundle = parseTeamRoster(homeRosterPlayersResp, homeTeamFullName);
	
		
		awayRoster.sort(sortArrayOfObj('player_name', 'asc'));
		homeRoster.sort(sortArrayOfObj('player_name', 'asc'));

	const homeHealthScore = game && game.home_team_gaming_score;
	const awayHealthScore = game && game.away_team_gaming_score;
	console.log('-----------------------homeHealthScore', homeHealthScore);
	const homeStatusText = checkHealthScoreStatus(homeHealthScore, false, 'team');
	const awayStatusText = checkHealthScoreStatus(awayHealthScore, false, 'team');
	let teamHighlightShadowAway;
	let teamHighlightShadowHome;
	const highlightCol = highlightColumn(homeHealthScore, awayHealthScore);
	if (highlightCol === 'away') {
		teamHighlightShadowAway = 'teamShadowHighlight';
	} else if (highlightCol === 'home') {
		teamHighlightShadowHome = 'teamShadowHighlight';
	}
	const homeHighlightColor = highlightColumnColor(homeHealthScore, 'teamHighlight');
	const awayHighlightColor = highlightColumnColor(awayHealthScore, 'teamHighlight');
	const offenseDefenseDesc = "This category reflects the avg health score of all core players' injuries on a specific team. It assesses their injury impact on performance as a group.";
		
	return (
		<section className='gameMainSection'>
			<div className='gameMainDiv'>
				<UserHeader matchup={true} backgroundColor={'#f7f7f7'} title={title} hideUserHeader={hideUserHeader} toggleScheduleView={() => toggleScheduleView()} game={game} />
				<div className='gameBoxShadow'>
					<Row className='gameSpreadHeaderRow'>
						<Col lg={6} className={`gameSpreadHeaderCol ${awayHighlightColor}`}>
							<div className='gameSpreadHeaderDiv'>
								<React.Fragment>
									<p className='gameSpreadHeaderSpread'>
										<span style={{ paddingRight: '20px' }}>{awayStatusText.status}</span>
										{awayHealthScore}
									</p>
									<p className='gameSpreadHeaderDescription'>Team Health Score</p>
								</React.Fragment>
							</div>
						</Col>
						<Col lg={6} className={`gameSpreadHeaderCol ${homeHighlightColor}`}>
							<div className='gameSpreadHeaderDiv'>
								<React.Fragment>
									<p className='gameSpreadHeaderDescription'>Team Health Score</p>
									<p className='gameSpreadHeaderSpread pull-right'>
										<span style={{ paddingRight: '20px' }}>{homeStatusText.status}</span>
										{homeHealthScore}
									</p>
								</React.Fragment>
							</div>
						</Col>
					</Row>
					<Row className='gameTeamHeaderRow'>
						<Col lg={6} className={`gameTeamHeaderCol ${teamHighlightShadowAway} col-xs-12`}>
							<div className='gameTeamHeaderDiv'>
								<p className={`gameTeamHeaderSpread bold ${awayHighlightColor}`}>{awayHealthScore}</p>
								<div className='gameTeamHeaderLogoDiv gameTeamHeaderLogoAwayDiv'>
									<img src={game.away_team_logo} alt='Team Logo' className='gameTeamLogo' />
									<p className='gameTeamHeaderName gameTeamHeaderNameAway'>{game.away_team_name}</p>
								</div>
							</div>
						</Col>
						<Col lg={6} className={`gameTeamHeaderCol ${teamHighlightShadowHome} col-xs-12`}>
							<div className='gameTeamHeaderDiv gameTeamHeaderDivHome'>
								<div className='gameTeamHeaderLogoDiv gameTeamHeaderLogoRightDiv'>
								<p className='gameTeamHeaderName gameTeamHeaderNameHome'>@ {game.home_team_name}</p>
								<img src={game.home_team_logo} alt='Team Logo' className='gameTeamLogo' />
								</div>
								<p className={`gameTeamHeaderSpread gameTeamHeaderSpreadRight bold ${homeHighlightColor}`}>{homeHealthScore}</p>
							</div>
						</Col>
					</Row>
					{game.game_description ? (
						<Row className='gameDescriptionRow'>
							<Col lg={12} className='gameDescriptionCol'>
								<p className='gameDescription'>{game.game_description}</p>
							</Col>
						</Row>
					) : null}
					<TeamLegend />
					{user?.login ? (
						<>
							<div className='topFourPlayerDiv'>
								<h1 className='dashboardHowItWorksHeader'>Impactful Players</h1>
							</div>
							<Row>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<h3 className='matchupHeaderTopMobile'>Away Team</h3>
										<hr className='hrStyleMobile' />
										<Row>
											{topFourAway?.length > 0 ? (
												topFourAway.map((players, i) => {
													return (
														<Col lg={6} key={i}>
															<Link
																className='routerLinkMatchup hover-delay'
																title={`${players.player_name}`}
																to={{
																	pathname: `/soccer/player/${players?.player_id}`,
																	playerID: players?.player_id
																}}
															>
																<div className='matchPlayerDiv'>
																	<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																		<p className='matchPlayerInfoNameTop'>{players.nickname || players.player_name}</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>POSITION:</span>
																			<span className='matchPlayerInfo'>{players.position}</span>
																		</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>HEALTH SCORE:</span>
																			<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																		</p>
																	</div>
																</div>
															</Link>
														</Col>
													);
												})
											) : (
												<Col lg={12} className='text-center'><p>No impactful players found</p></Col>
											)}
										</Row>
									</div>
								</Col>
								<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
									<div className='matchupHeaderDiv'>
										<hr className='hrStyleMobile' />
										<h3 className='matchupHeaderTopMobile'>Home Team</h3>
										<hr className='hrStyleMobile' />
										<Row>
											{topFourHome?.length > 0 ? (
												topFourHome.map((players, i) => {
													return (
														<Col lg={6} key={i}>
															<Link
																className='routerLinkMatchup hover-delay'
																title={`${players.player_name}`}
																to={{
																	pathname: `/soccer/player/${players?.player_id}`,
																	playerID: players?.player_id
																}}
															>
																<div className='matchPlayerDiv'>
																	{/* <img
																		src={game.home_team_logo}
																		alt="Player"
																		className="matchPlayerImg displayTableCell"
																	/> */}
																	<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																		<p className='matchPlayerInfoNameTop'>{players.nickname || players.player_name}</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>POSITION:</span>
																			<span className='matchPlayerInfo'>{players.position}</span>
																		</p>
																		<p className='matchPlayerInfoInjury'>
																			<span className='grey'>HEALTH SCORE:</span>
																			<span className='matchPlayerInfo'>{players.gaming_score || '10'}</span>
																		</p>
																	</div>
																</div>
															</Link>
														</Col>
													);
												})
											) : (
												<Col lg={12} className='text-center'><p>No impactful players found</p></Col>
											)}
										</Row>
									</div>
								</Col>
							</Row>
						</>
					) : null}

					{(awayRosterBundle || homeRosterBundle) ? (
								<>
									<Row>
										<Col lg={12}>
											<h1 className='dashboardHowItWorksHeader'>Roster Players</h1>
										</Col>
									</Row>
									<Row className='gameMatchupRow'>
										{/* Away Roster */}
										<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
											<div className='matchupHeaderDiv'>
												<Row>
													<Col lg={12} className='matchupHeaderCol'>
														<hr className='hrStyleMobile' />
														<p className='matchupMobileHeader'>{[game.away_team_city, game.away_team_name].filter(v => v && v !== 'null').join(' ')}</p>
														<hr className='hrStyleMobile' />
													</Col>
												</Row>
											</div>
											<div style={{ paddingBottom: '30px' }}>
												{awayRosterBundle?.active_roster?.length ? (
													<div style={{ marginBottom: '16px' }}>
														<Row>
															{awayRosterBundle.active_roster.map((p, idx) => (
																<Col lg={6} key={`away-act-${idx}`}>
																	<div className='matchPlayerDiv'>
																		<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																			<Link
																				className='routerLinkMatchup hover-delay'
																				title={`${p.full_name}`}
																				to={p?.player_id ? `/nba/player/${p.player_id}` : '#'}
																			>
																				<p className='matchPlayerInfoNameTop'>{p.full_name}</p>
																				<p className='matchPlayerInfoInjury'>
																					<span className='grey'>POSITION:</span>
																					<span className='matchPlayerInfo'>{p.position}</span>
																				</p>
																				<p className='matchPlayerInfoInjury'>
																					<span className='grey'>HEALTH SCORE:</span>
																					<span className='matchPlayerInfo'>{p.gaming_score || '10'}</span>
																				</p>
																			</Link>
																		</div>
																	</div>
																</Col>
															))}
														</Row>
													</div>
												) : null}
											</div>
										</Col>
										{/* Home Roster */}
										<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol2'>
											<div className='matchupHeaderDiv'>
												<Row>
													<Col lg={12} className='matchupHeaderCol'>
														<hr className='hrStyleMobile' />
														<p className='matchupMobileHeader'>{[game.home_team_city, game.home_team_name].filter(v => v && v !== 'null').join(' ')}</p>
														<hr className='hrStyleMobile' />
													</Col>
												</Row>
											</div>
											<div style={{ paddingBottom: '30px' }}>
												{homeRosterBundle?.active_roster?.length ? (
												<div style={{ marginBottom: '16px' }}>                                                
													<Row>
														{homeRosterBundle.active_roster.map((p, idx) => (
															<Col lg={6} key={`home-act-${idx}`}>
																<div className='matchPlayerDiv'>
																	<div className='matchPlayerInfoDiv matchPlayerInfoTopDiv'>
																		<Link
																			className='routerLinkMatchup hover-delay'
																			title={`${p.full_name}`}
																			to={p?.player_id ? `/nba/player/${p.player_id}` : '#'}
																		>
																			<p className='matchPlayerInfoNameTop'>{p.full_name}</p>
																		
																			<p className='matchPlayerInfoInjury'>
																				<span className='grey'>POSITION:</span>
																				<span className='matchPlayerInfo'>{p.position}</span>
																			</p>
																			<p className='matchPlayerInfoInjury'>
																				<span className='grey'>HEALTH SCORE:</span>
																				<span className='matchPlayerInfo'>{p.gaming_score || '10'}</span>
																			</p>
																		</Link>	
																	</div>
																</div>
															</Col>
														))}
													</Row>
												</div>
											) : null}
											</div>
										</Col>
									</Row>
								</>
							) : null}
					<Row className='gameMatchupRow soccerMatchupRow'>
						{/* Away Team */}
						<Col lg={12}>
							<h1 className='dashboardHowItWorksHeader'>Position Categories</h1>
						</Col>
						<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol1'>
							<div className='matchupHeaderDiv'>
								<Row>
									<Col lg={8} className='matchupHeaderCol'>
										<hr className='hrStyleMobile' />
										<p className='matchupMobileHeader'>
											{/* {game.away_team_city} {game.away_team_name} */}
											{[game.away_team_city, game.away_team_name].filter(v => v && v !== 'null').join(' ')}
										</p>
										<hr className='hrStyleMobile' />
									</Col>
									<Col lg={3} className='matchupHeaderCol'>
										<p className='matchupHeader'>Health Score</p>
									</Col>
									<Col lg={1} />
								</Row>
							</div>
							<React.Fragment>
								<div style={{ paddingBottom: '30px' }}>									
									{positionGroups.map(group => {										
										const playersInGroup = awayRoster.filter(
											player => player.position?.toUpperCase() === group.id
										);

										return (
											<PlayerPanel
												key={group.id}
												id={group.id}
												healthScoreStatus={checkHealthScoreStatus(game.away_team_gaming_score, playersInGroup, 'team')}
												players={playersInGroup}
												panelTitle={group.label}
												tooltip={offenseDefenseDesc}
												openAll={expandedAwayGroups[group.id] || false}
												toggleRosterView={() => toggleGroupAway(group.id)}
												sportsName="soccer"
												teamLogo={game.away_team_logo}
												hideDropdown={false}
												ignoreCategories={true}
											/>
										);
									})}
								</div>
							</React.Fragment>
						</Col>

						{/* Home Team */}

						<Col lg={6} className='gameMatchupHeaderCol gameMatchupHeaderCol2'>
							<div className='matchupHeaderDiv'>
								<Row>
									<Col lg={8} className='matchupHeaderCol'>
										<hr className='hrStyleMobile' />
										<p className='matchupMobileHeader'>
											{/* {game.home_team_city} {game.home_team_name} */}
											{[game.home_team_city, game.home_team_name].filter(v => v && v !== 'null').join(' ')}
										</p>
										<hr className='hrStyleMobile' />
									</Col>
									<Col lg={3} className='matchupHeaderCol'>
										<p className='matchupHeader'>Health Score</p>
									</Col>
									<Col lg={1} />
								</Row>
							</div>
							<React.Fragment>
								<div style={{ paddingBottom: '30px' }}>
									{/* <PlayerPanel
										id={4}
										healthScoreStatus={checkHealthScoreStatus(game.home_team_gaming_score, homeRoster, 'team')}
										players={homeRoster}
										panelTitle='ALL ACTIVE PLAYERS'
										tooltip={offenseDefenseDesc}
										openAll={showHomeRoster}
										toggleRosterView={() => toggleRosterView('home')}
										sportsName='soccer'
										teamLogo={game.home_team_logo}
										hideDropdown={true}
										ignoreCategories={true}
									/> */}
									{positionHomeGroups.map(group => {										
										const playersInHomeGroup = homeRoster.filter(
											player => player.position?.toUpperCase() === group.id
										);

										return (
											<PlayerPanel
												key={group.id}
												id={group.id}
												healthScoreStatus={checkHealthScoreStatus(game.home_team_gaming_score, homeRoster, 'team')}
												players={playersInHomeGroup}
												panelTitle={group.label}
												tooltip={offenseDefenseDesc}
												openAll={expandedHomeGroups[group.id] || false}
												toggleRosterView={() => toggleGroupHome(group.id)}
												sportsName="soccer"
												teamLogo={game.away_team_logo}
												hideDropdown={false}
												ignoreCategories={true}
											/>
										);
									})}
								</div>
							</React.Fragment>
						</Col>
					</Row>
				</div>
			</div>
		</section>
	);
}

const mapStateToProps = (state) => ({
	isLoading: state.isLoading,
	isLoaded: state.isLoaded,
	healthScores: state.healthScores,
	match: state.match,
	schedules: state.schedules,
	teams: state.teams,
	user: state.user
});

export default connect(mapStateToProps)(SoccerMatchup);
